import { useRef, useState } from "react";
import useGetActorSummary from "../../../hooks/useGetActorSummary";
import { Grid, RLCard } from "../../../../../components";
import AIGeneratedIcon from "../../../../../components/icons/AIGeneratedIcon";
import { usePagination } from "../../../../../hooks";
import { sortGridByColumn } from "../../../../../utils";
import { ActorTTPSSchema } from "../ActorTTPSSchema";
import { SortParams } from "../../../@types/rldynamicanalysis/yara";
import { ActorInsightsProps } from "../../../@types/actor";

const ActorTTPS = ({ actorName }: ActorInsightsProps) => {
  const gridRef = useRef<HTMLDivElement>(null);
  const { data: actorData } = useGetActorSummary(actorName || "");
  const actorRelatedTTPS = actorData?.ttps || [];

  const { data, currentPageData, updatePageData } = usePagination(
    actorRelatedTTPS,
    { pageSize: 10 }
  );

  const [sort, setSort] = useState({
    field: "default",
    direction: "asc"
  });

  const handlePageChange = (newPage: number, newPageSize?: number): void => {
    updatePageData({ newPage, newPageSize });
    gridRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleSortChange = (sortParams: SortParams) => {
    const { field, direction } = sort;
    if (sortParams.direction === direction && sortParams.field === field)
      return;
    setSort(sortParams);
    sortGridByColumn(data, sortParams);
  };

  return (
    <RLCard
      header={
        <RLCard.Header>
          <div className="flex flex-center flex-gap-2">
            <span>Actor Related TTPs</span>
            <AIGeneratedIcon />
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          {actorRelatedTTPS.length > 0 ? (
            <div ref={gridRef}>
              <Grid
                schema={ActorTTPSSchema}
                data={data}
                totalResults={actorRelatedTTPS.length}
                page={currentPageData.page}
                pageSize={currentPageData.pageSize}
                onPageChange={handlePageChange}
                numPages={currentPageData.numPages}
                showPageNumbers
                sort={sort}
                onSortChange={handleSortChange}
                enablePageSizeSelector
                pageSizeSelectorItems={[
                  { label: "10", value: "10" },
                  { label: "20", value: "20" },
                  { label: "50", value: "50" },
                  { label: "100", value: "100" },
                  { label: "200", value: "200" }
                ]}
              />
            </div>
          ) : (
            <span> No related TTPS data available for this actor.</span>
          )}
        </RLCard.Content>
      }
    />
  );
};

export default ActorTTPS;
